import React, { useState } from "react"

const NewPagination = ({
  gotoPage,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageOptions,
  pageSize,
  page,
  data,
  nextPage,
  previousPage,
}) => {
  const currentEntries = pageIndex * pageSize + 1
  const endEntry = pageIndex * pageSize + page.length
  const totalEntries = data.length

  const totalPages = pageOptions.length
  const visiblePages = 10 // number of pages to show in pagination window

  // Calculate start and end page numbers for pagination window
  let startPage = Math.max(pageIndex - Math.floor(visiblePages / 2), 0)
  let endPage = startPage + visiblePages

  if (endPage > totalPages) {
    endPage = totalPages
    startPage = Math.max(endPage - visiblePages, 0)
  }

  const pageNumbers = []
  for (let i = startPage; i < endPage; i++) {
    pageNumbers.push(i)
  }

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
        <p>
          Showing {data?.length === 0 ? 0 : currentEntries} to {endEntry} of{" "}
          {totalEntries} entries
        </p>

        <div className="d-flex align-items-md-center justify-content-md-end flex-column flex-md-row">
          <div>
            <ul className="pagination m-0">
              {/* Previous */}
              <li
                className={`page-item ${canPreviousPage ? "" : "disabled"}`}
                onClick={canPreviousPage ? previousPage : undefined}
              >
                <span className="page-link">Previous</span>
              </li>

              {/* Page numbers */}
              {pageNumbers.map(pageNumber => (
                <li
                  key={pageNumber}
                  className={`page-item ${
                    pageNumber === pageIndex ? "bg-purple" : ""
                  }`}
                  onClick={() => gotoPage(pageNumber)}
                >
                  <span
                    className={`page-link ${
                      pageNumber === pageIndex ? "bg-purple" : ""
                    }`}
                  >
                    {pageNumber + 1}
                  </span>
                </li>
              ))}

              {/* Next */}
              <li
                className={`page-item ${canNextPage ? "" : "disabled"}`}
                onClick={canNextPage ? nextPage : undefined}
              >
                <span className="page-link">Next</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPagination
